import {Dimensions, Platform, StyleSheet} from 'react-native';

import {denim} from '/theme/color/on.color';

const {width, height} = Dimensions.get('window');
const isLandscape = width > height;

export const styles = StyleSheet.create({
  qualificationBox: {
    backgroundColor: '#EEF4FF',
    borderRadius: 10,
    paddingHorizontal: 20,
    paddingVertical: 12,
    marginBottom: 20,
    borderWidth: 1,
    borderColor: '#D6E4FF',

    ...(isLandscape && {
      paddingRight: 32,
    }),
  },

  qualificationTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },

  qualificationIcon: {
    color: denim,
    fontSize: 22,
    marginRight: 8,
    marginTop: 1,
  },

  bold: {
    fontWeight: '700',
  },

  qualificationTitle: {
    fontWeight: '700',
    fontSize: 14,
    lineHeight: 20,
    color: '#1A1A1A',
    flexShrink: 1,
  },
  qualificationBody: {
    fontSize: 13,
    color: '#1C1C1E',
    marginBottom: 5,
    lineHeight: 19,
  },

  bulletRow: {
    flex: 1,
    flexDirection: 'row',
    paddingLeft: 15,
    marginBottom: 4,
  },

  bullet: {
    fontSize: 13,
    color: '#1C1C1E',
    marginRight: 8,
    lineHeight: 19,
  },

  bulletText: {
    fontSize: 13,
    color: '#1C1C1E',
    lineHeight: 19,
    flexShrink: 1,
  },

  qualificationFootnote: {
    fontSize: 11,
    color: '#5F6368',
    marginTop: 8,
    lineHeight: 14,
  },

  radioWrapper: {
    marginBottom: 16,
  },
  questionText: {
    fontWeight: '700',
    fontSize: 13,
    color: '#1A1A1A',
    marginBottom: 12,
    lineHeight: 19,
  },

  warningBox: {
    backgroundColor: '#F2F4F7',
    borderColor: '#E4E7EC',
    borderRadius: 8,
    padding: 14,
    marginBottom: 24,
    borderWidth: 1,

    ...(isLandscape && {
      paddingRight: 32,
    }),
  },
  warningText: {
    fontSize: 12,
    color: '#667085',
    lineHeight: 18,
  },

  customFooter: {
    marginTop: 10,
    paddingBottom: Platform.OS === 'ios' ? 20 : 10,
  },

  radioSubLabel: {
    fontSize: 12,
    color: 'black',
    lineHeight: 18,
    marginTop: 5,
  },
  radioOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    zIndex: 1,
  },
});
